import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { StatisticsItemModel } from '../../../models/statistics-item.model';
import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-top-shareholders-chart',
    templateUrl: './top-shareholders-chart.component.html',
    styleUrls: ['./top-shareholders-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopShareholdersChartComponent implements OnInit {
    chartData: StatisticsItemModel[] = [];

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getShareDistribution().subscribe(resp => {
            const processed: StatisticsItemModel[] = [];
            const total = resp.value.reduce((a, b) => a + b.value, 0);
            let currentPercentage = 0;

            for (let i = 0; i < resp.value.length; i++) {
                const item = resp.value[i];
                const percentage = i === resp.value.length - 1 ? 100 - currentPercentage : +((item.value / total) * 100).toFixed(2);

                processed.push(
                    new StatisticsItemModel({
                        value: item.value,
                        label: `${item.label} (${percentage.toFixed(2)})%`
                    })
                );

                currentPercentage += percentage;
            }

            this.chartData = processed;
        });
    }
}
